import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcMyFillH18(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    fill: "none",
    viewBox: "0 0 18 18",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.592 5.302a3.591 3.591 0 1 1-7.182 0 3.591 3.591 0 0 1 7.182 0M15.9 14.493c0 .91-.738 1.65-1.65 1.65H3.75a1.65 1.65 0 0 1-1.65-1.65v-1.148a3.65 3.65 0 0 1 3.65-3.65h6.5a3.65 3.65 0 0 1 3.65 3.65z"
  }));
}
var IcMyFillH18 = createNolIcon(/*#__PURE__*/forwardRef(SvgIcMyFillH18));

export { IcMyFillH18 as I };
